// Site copy and company facts — one source of truth for every page.

export const COMPANY = {
  name: "VoltNaPřání",
  owner: "Josef Černý",
  street: "Šípková 1868/8",
  city: "Praha 4, 142 00",
  ico: "74140281",
  phone: "+420 736 656 131",
  email: "info@voltnaprani.cz",
  hours: "Po–Pá 9:00–18:00",
  facebook: "https://www.facebook.com/profile.php?id=61580790219079",
};

export const telHref = (phone) => `tel:${phone.replace(/\s/g, "")}`;

// Shown on About. Keep these honest — they are the only numbers on the site.
export const STATS = [
  { value: "20+", label: "prodaných elektromobilů", icon: "car" },
  { value: "98 %", label: "spokojených zákazníků", icon: "users" },
  { value: "4,8 / 5", label: "průměrné hodnocení", icon: "check-circle" },
  { value: "1 rok", label: "v oboru", icon: "clock" },
];

// Short, factual promises used in the hero and on the import page.
export const PROMISES = [
  { icon: "globe", text: "Vozy z celé EU, stáří 1–6 let" },
  { icon: "file-text", text: "Dovozová STK a registrace v ceně" },
  // TODO: warranty periods pending legal review — keep neutral until the purchase contract is settled.
  { icon: "shield-check", text: "Prověřený stav a kompletní dokumentace" },
  { icon: "receipt", text: "U většiny vozů odpočet DPH" },
];

export const IMPORT_STEPS = [
  { icon: "file-text", title: "Poptávka", text: "Vyplníte pár parametrů — značku, model, rok výroby a rozpočet. Do 24 hodin se ozveme s nabídkou." },
  { icon: "search", title: "Vyhledání a ověření", text: "Prohledáme trhy EU a vybereme vozy s čistou historií, zdravou baterií a ověřeným nájezdem." },
  { icon: "truck", title: "Dovoz a příprava", text: "Zajistíme přepravu, STK i přihlášení na EL značky. Auto vyčistíme a připravíme k předání." },
  { icon: "key", title: "Předání klíčů", text: "Vozidlo předáme osobně nebo ho dovezeme až k vám — připravené k okamžité jízdě." },
];

export const SERVICES = [
  {
    icon: "search", title: "Výběr vozidla",
    text: "Tisíce elektromobilů z celé EU. Vybíráme jen vozy s čistou historií, zdravou baterií a ověřeným nájezdem.",
    points: ["Přístup k vozům z celé Evropy", "Jen vozy bez škod a s čistým titulem", "Podle vašeho rozpočtu a požadavků", "Osobní konzultace se specialistou"],
  },
  {
    icon: "wrench", title: "Technická kontrola",
    text: "Zpráva o stavu baterie a servisní historii ještě před koupí. Žádná skrytá překvapení po dovozu.",
    points: ["Diagnostika kapacity a zdraví baterie (SOH)", "Fyzická nebo virtuální prohlídka", "Kompletní servisní dokumentace"],
  },
  {
    icon: "truck", title: "Doprava a registrace",
    text: "Přeprava, papíry, STK i přihlášení v ČR. Auto dorazí připravené k jízdě.",
    points: ["Přeprava z kterékoli země EU", "Kompletní daňová administrativa", "Registrace a STK v ČR v ceně", "Předání na vaší adrese"],
  },
  {
    icon: "sparkles", title: "Čištění",
    text: "Každé auto projde důkladnou očistou zvenku i zevnitř. Parní čištění zničí 99 % bakterií.",
    points: ["Parní čištění interiéru i exteriéru", "Dezinfekce bakterií a roztočů", "Čištění klimatizace a ventilace"],
  },
  {
    icon: "shield-check", title: "Záruka",
    text: "Tovární záruka na pohon a baterii a navíc týden na vrácení vozu, pokud nebudete spokojeni.",
    points: ["Tovární záruka na pohon a baterii", "Týden na vrácení bez udání důvodu", "Záruka na skryté vady"],
  },
  {
    icon: "steering-wheel", title: "Testovací jízda",
    text: "Skladové vozy si můžete projet. Stačí napsat nebo zavolat a domluvíme termín.",
    points: ["Jízda se skladovými vozy", "Termín podle vašich možností", "Bez závazků a poplatků"],
  },
];

export const FAQ = [
  { q: "Jak dlouho trvá dovoz elektromobilu?", a: "Celý proces obvykle trvá 2–4 týdny od výběru vozidla po předání klíčů. Záleží na dostupnosti konkrétního modelu a vzdálenosti přepravy. O každém kroku vás průběžně informujeme." },
  { q: "Jaká je záruka na dovezená vozidla?", a: "Na všechna vozidla se vztahuje záruka na skryté vady a dodáváme k nim kompletní technickou zprávu. Před dovozem prochází každý vůz důkladnou kontrolou baterie a mechaniky." },
  { q: "Kolik ušetřím oproti českému dealerovi?", a: "Průměrná úspora je 15–35 % podle značky a modelu. U prémiových vozů jako Tesla nebo BMW může úspora dosáhnout 200 000–400 000 Kč oproti české tržní ceně." },
  { q: "Zajistíte i přihlášení vozidla v ČR?", a: "Ano. Kompletní administrativa včetně STK a registrace v ČR je součástí služby. Vozidlo předáme s českou SPZ, připravené k provozu." },
  { q: "Mohu si vozidlo před koupí prohlédnout?", a: "Samozřejmě. Skladové vozy si můžete kdykoli prohlédnout a vyzkoušet na testovací jízdě." },
  { q: "Jaké elektromobily dovážíte?", a: "Tesla, BMW, Mercedes-Benz, Audi, Volkswagen, Hyundai, Volvo, Polestar a další značky. Hledáte konkrétní model? Napište nám a najdeme ho." },
];

export const CLEANING_STEPS = [
  { title: "Vnější mytí karoserie", text: "Ruční předmytí, odstranění asfaltu a hmyzu. Šetrné mytí bez automatických kartáčů." },
  { title: "Parní čištění interiéru", text: "Pára o teplotě 140 °C vyčistí a dezinfikuje každý povrch — sedadla, koberce, madla i vzduchové kanálky." },
  { title: "Dezinfekce 99 % bakterií", text: "Horká pára ničí bakterie, roztoče a plísně bez chemie. Bezpečné pro alergiky i děti." },
  { title: "Finální detailing", text: "Ošetření palubní desky, čištění skel a vůně interiéru. Vůz předáváme jako nový." },
];

export const CLEANING_HIGHLIGHTS = [
  { icon: "droplets", title: "Bez chemie", text: "Čistíme výhradně párou — žádné agresivní přípravky, žádné zbytky." },
  { icon: "shield-check", title: "Záruka čistoty", text: "Každý vůz před předáním kontrolujeme. Nejste spokojeni? Vyčistíme ho znovu." },
  { icon: "timer", title: "Do 4 hodin", text: "Kompletní detailing zvládneme zpravidla za 2–4 hodiny." },
];

export const ABOUT_BLOCKS = [
  { icon: "globe", title: "Naše poslání", text: "VoltNaPřání vzniklo v roce 2025 a specializuje se na individuální dovoz elektromobilů ze zahraničí. Dovoz z celé EU zajišťujeme transparentně a za dostupné ceny, u všech vozů děláme diagnostiku. Pomůžeme vám s hladkým přechodem na bezemisní mobilitu." },
  { icon: "search", title: "Jak dovážíme", text: "Každý vůz prochází kontrolou stavu baterie, nabíjecích systémů, softwaru, karoserie i mechanických součástí. Auta čistíme zevnitř i zvenku, na přání je chráníme leštěním a keramickou ochranou. Zajistíme dovozovou STK i přihlášení na EL značky." },
  { icon: "users", title: "Náš tým", text: "Máme zkušenosti se značkami Tesla, VW a Škoda. Technická znalost nám pomáhá zaručit odpovídající kvalitu každého dovezeného vozu.", photo: "/team-josef.jpg" },
  { icon: "leaf", title: "Udržitelnost", text: "Každý elektromobil na silnici zvyšuje komfort přepravy a kvalitu prostředí, ve kterém žijeme, a může jezdit na lokální zdroje energie." },
];
